import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, getCurrentInstance, onMounted } from "vue";
import { VRow, VCol, VRadio, VRadioGroup, VSelect } from "vuetify/lib";
import { VacationFlowDat } from "@/models/transaction/VacationFlowDat";
import { InputRules } from "@/rules";
import { EnumWorkClassification } from "@/models/enum/Enum";
import {
  PulldownResponse,
  codeKbnFilter
} from "@/models/response/PulldownResponse";
import { CodeKbnList, CodeKbnType } from "@/models/codeMaster/Code";
import { $get } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";

type halfholidayKbn = typeof halfholidayKbn[keyof typeof halfholidayKbn];
// 半休区分の選択肢
type ReasonKbn = typeof ReasonKbn[keyof typeof ReasonKbn];

export type FormType = {
  vacationKbn?: EnumWorkClassification;
  halfholidayKbn?: halfholidayKbn;
  resonKbn?: ReasonKbn;
  resonText?: string;
  confimerText?: string;
};

type Props = {
  value: FormType;
};

type Emits = {
  (e: "update:modelValue", value: FormType): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'VacationForm',
  props: {
    value: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "update:modelValue", value: FormType): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: FormType;
};

const store = getCurrentInstance()?.proxy?.$store;
const shozokuCode1 = computed(() => {
  return store?.state?.shozokuCode1 || "";
});

const vacationKbn = computed(() => {
  const vKbn = [
    { text: "有給", value: EnumWorkClassification.PAID_HOLIDAY },
    { text: "欠勤", value: EnumWorkClassification.ABSENCE_DAY },
    { text: "特別休暇", value: EnumWorkClassification.SPECIAL_HOLIDAY }
    // { text: "計画有給", value: EnumWorkClassification.PAID_SCHEDULE_HOLIDAY }
  ];

  if (shozokuCode1.value === "34") {
    return [
      ...vKbn.slice(0, 1),
      { text: "半休", value: EnumWorkClassification.PAID_HALF_HOLIDAY },
      ...vKbn.slice(1)
    ];
  } else {
    return vKbn;
  }
});

// 半休区分の定数
const halfholidayKbn = {
  am: "0",
  pm: "1"
} as const;
const halfHolidayTypes = [
  { text: "午前休", value: halfholidayKbn.am },
  { text: "午後休", value: halfholidayKbn.pm }
];

const ReasonKbn = {
  self: "1",
  ceremonial: "2",
  special: "3"
} as const;
const reasonKbn = [
  { text: "私用", value: ReasonKbn.self },
  { text: "慶弔", value: ReasonKbn.ceremonial },
  { text: "特別", value: ReasonKbn.special }
];

/*const selfReason = ["通院", "家庭の事情", "体調不良", "その他"];

const ceremonialReason = [
  "配偶者の死去",
  "子、父母、同居の義父母の死去",
  "血族の兄弟姉妹、同居の祖父母の死去",
  "結婚休暇",
  "子の結婚休暇",
  "妻の出産休暇",
  "その他"
];

const specialReason = ["病院様都合", "会社都合", "その他"];*/



const reasonList = ref<string[]>([]);
const confirmerList = ref<string[]>([]);

console.log("storee?.state : ", store?.state);

const modelValue = computed({
  get: () => props.value,
  set: newValue => emits("update:modelValue", newValue)
});

const isVacationKbnOther = computed(
  () => modelValue.value.vacationKbn === EnumWorkClassification.OTHER
);
const isVacationKbnSpecial = computed(
  () => modelValue.value.vacationKbn === EnumWorkClassification.SPECIAL_HOLIDAY
);
const isVacationKbnPaidHoliday = computed(
  () => modelValue.value.vacationKbn === EnumWorkClassification.PAID_HOLIDAY
);
const isVacationKbnPaidHalfHoliday = computed(
  () =>
    modelValue.value.vacationKbn === EnumWorkClassification.PAID_HALF_HOLIDAY
);
const isVacationKbnAbsence = computed(
  () => modelValue.value.vacationKbn === EnumWorkClassification.ABSENCE_DAY
);
const isVacationKbnSchedule = computed(
  () =>
    modelValue.value.vacationKbn ===
    EnumWorkClassification.PAID_SCHEDULE_HOLIDAY
);

const isReasonCeremonial = (kbn: ReasonKbn) => {
  return false;
};
const isReasonSpecial = (kbn: ReasonKbn) => {
  return false;
};
const isReasonSelf = (kbn: ReasonKbn) => {
  console.log(isVacationKbnPaidHoliday, "paid");
  console.log(isVacationKbnSpecial, "special");
  return (
    (kbn !== ReasonKbn.self &&
      (isVacationKbnPaidHoliday.value ||
        isVacationKbnPaidHalfHoliday.value ||
        isVacationKbnAbsence.value ||
        isVacationKbnSchedule.value)) ||
    (kbn === ReasonKbn.self && isVacationKbnSpecial)
  );
};

const getCodeMaster = async (type: CodeKbnType) => {
  const code = await $get<PulldownResponse[]>(Paths.codeMasterPulldown);
  if (code) {
    reasonList.value = codeKbnFilter(code, type).map(e => e.name);
    modelValue.value.resonText = undefined;
  }
};
const [office, employeeNames] = [ref(), ref<PulldownResponse[]>()];

onMounted(async () => {
  const [officee, employeeNamee, confirmer] = (await Promise.all([
    $get(Paths.shozoku),
    $get(Paths.shainSorted),
    $get(Paths.petitionFindAll)
  ])) as [PulldownResponse[], PulldownResponse[], any[]];

  const incode = store?.state.incode;
  const o = officee.filter(k => k.code === incode)[0].code;

  office.value = o;

  const confirmerCode = [
    ...confirmer
      .filter(k => k.affiliationId === Number(o))
      .map(k => k.confimerId)
  ];

  const employee = employeeNamee.filter(k =>
    confirmerCode.includes(Number(k.code))
  );
  confirmerList.value = employee.map(k => k.name);
  modelValue.value.confimerText = undefined;
});

watch(isVacationKbnOther, val => {
  if (val) modelValue.value.resonKbn = ReasonKbn.ceremonial;
});
watch(isVacationKbnSpecial, val => {
  if (val) modelValue.value.resonKbn = ReasonKbn.special;
});
watch(isVacationKbnPaidHoliday, val => {
  if (val) {
    modelValue.value.resonKbn = ReasonKbn.self;
    modelValue.value.halfholidayKbn = undefined;
  }
});
watch(isVacationKbnPaidHalfHoliday, val => {
  if (val) {
    modelValue.value.resonKbn = ReasonKbn.self;
    // 半休選択時はデフォルトで午前休を設定
    if (!modelValue.value.halfholidayKbn) {
      modelValue.value.halfholidayKbn = halfholidayKbn.am;
    }
  } else {
    modelValue.value.halfholidayKbn = undefined;
  }
});
watch(isVacationKbnAbsence, val => {
  if (val) {
    modelValue.value.resonKbn = ReasonKbn.self;
    modelValue.value.halfholidayKbn = undefined;
  }
});
watch(isVacationKbnSchedule, val => {
  if (val) {
    modelValue.value.resonKbn = ReasonKbn.self;
    modelValue.value.halfholidayKbn = undefined;
  }
});

watch(
  () => modelValue.value.resonKbn,
  async newValue => {
    switch (newValue) {
      case ReasonKbn.self:
        //this.reasonList = selfReason;
        await getCodeMaster(CodeKbnList.SELRSN);
        break;
      case ReasonKbn.ceremonial:
        //this.reasonList = ceremonialReason;
        await getCodeMaster(CodeKbnList.CRERSN);
        break;
      case ReasonKbn.special:
        //this.reasonList = specialReason;
        await getCodeMaster(CodeKbnList.SPRSN);
        break;
    }
  },
  { immediate: true }
);

return { __sfc: true,store, shozokuCode1, vacationKbn, halfholidayKbn, halfHolidayTypes, ReasonKbn, reasonKbn, props, emits, reasonList, confirmerList, modelValue, isVacationKbnOther, isVacationKbnSpecial, isVacationKbnPaidHoliday, isVacationKbnPaidHalfHoliday, isVacationKbnAbsence, isVacationKbnSchedule, isReasonCeremonial, isReasonSpecial, isReasonSelf, getCodeMaster, office, employeeNames, VRow, VCol, VRadio, VRadioGroup, VSelect, InputRules }
}

})